// extracted by mini-css-extract-plugin
export default {"button":"ButtonMain_button__qTaQW"};